import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { faSpinner, faExclamationTriangle, faTimes, faCircleInfo, faCoins, faArrowRight, faArrowLeft, faCalculator, faFloppyDisk } from '@fortawesome/free-solid-svg-icons';
import { ResultsService } from '../../services/results.service';
import { ModalCreateEditComponent } from '../modal-creat-edit-config/modal-create-edit.component';

@Component({
  selector: 'app-modal-execution-details',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, TranslateModule, ModalCreateEditComponent],
  templateUrl: './modal-execution-details.component.html',
  styleUrls: ['./modal-execution-details.component.scss']
})
export class ModalExecutionDetailsComponent implements OnInit {
  @Input() interactionId!: string;
  @Input() resultId!: string;
  @Output() close = new EventEmitter<void>();

  loading = false;
  error = '';
  details: any = null;

  showCreateOcrModal = false;
  ocrPrefillValue: Record<string, any> | null = null;

  icons = {
    faSpinner,
    faExclamationTriangle,
    faTimes,
    faCircleInfo,
    faCoins,
    faArrowRight,
    faArrowLeft,
    faCalculator,
    faFloppyDisk
  };

  constructor(private resultsService: ResultsService) {}

  ngOnInit(): void {
    this.loadDetails();
  }

  loadDetails(): void {
    if (!this.interactionId || !this.resultId) return;

    this.loading = true;
    this.error = '';
    
    this.resultsService.getExecutionDetails(this.interactionId, this.resultId)
      .subscribe({
        next: (response: any) => {
          this.loading = false;
          this.details = response.details;
        },
        error: (error: any) => {
          this.loading = false;
          this.error = error.error?.message || 'ERROR.LOADING.EXECUTION_DETAILS';
        }
      });
  }

  onClose(): void {
    this.close.emit();
  }

  openSaveOcrAsNew(): void {
    const ocrConfig = this.details?.interaction_snapshot?.di2winocr_features_config;
    if (!ocrConfig?.value) return;
    this.ocrPrefillValue = { ...ocrConfig.value };
    this.showCreateOcrModal = true;
  }

  onCreateOcrClose(): void {
    this.showCreateOcrModal = false;
  }

  onOcrConfigCreated(): void {
    this.showCreateOcrModal = false;
  }

  getLanguageLabelKey(language?: string): string {
    const normalized = (language || 'pt').toLowerCase();
    switch (normalized) {
      case 'en':
        return 'SETTINGS.PREFERENCES.AI_MODEL_LANGUAGE_OPTIONS.EN';
      case 'es':
        return 'SETTINGS.PREFERENCES.AI_MODEL_LANGUAGE_OPTIONS.ES';
      case 'pt':
      default:
        return 'SETTINGS.PREFERENCES.AI_MODEL_LANGUAGE_OPTIONS.PT';
    }
  }

  getAverageTokens(type: 'input' | 'output' | 'total'): number {
    if (!this.details?.token_usage?.total || !this.details?.interaction_snapshot?.archives?.length) {
      return 0;
    }
    const total = this.details.token_usage.total[type] || 0;
    const count = this.details.interaction_snapshot.archives.length;
    return Math.round(total / count);
  }

  getTokensForArchive(archiveId: string): any {
    return this.details?.token_usage?.per_archive?.[archiveId] || null;
  }
}
